declare var jQuery: any;

export class Select2Utility{    
    
    constructor(){}

    static refresh() : void {

        jQuery(".select2").select2();

    }

    static select(id : string) : any{
        return jQuery('#' + id).find(':selected').val();
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/utilities/select2.utility.ts